<!-- Items -->
<div
	class="parent-container flex flex-column"
	*ngFor="let transaction of payoutTransactions; let i = index; last as isLast"
>
	<div class="header">
		<div class="header-content flex flex-row">
			<div class="flex flex-align-center-start flex-1" style="--max-width: 4%">
				<div
					*ngIf="
						(bulkSelected$ | async) &&
						canReprocessPayment &&
						selectedBulkRelevantStatuses.includes(transaction.status.name.toString())
					"
				>
					<mat-checkbox
						color="primary"
						class="checkbox"
						[checked]="isCheckBoxSelected && reprocessIds.includes(transaction.id)"
						(change)="setIds($event, payout.id, transaction.id)"
						[disabled]="!activeToggle"
					></mat-checkbox>
				</div>
			</div>

			<div class="employee-id table-row-item flex flex-align-center-start flex-1" style="--max-width: 15%">
				{{ employeeExternalId }}
			</div>
			<div style="--max-width: 10%" class="name table-row-item flex flex-align-center-start flex-1">
				{{ employeefirstName }}
			</div>

			<div style="--max-width: 12.8%" class="name table-row-item flex flex-align-center-start flex-1">
				{{ employeelastName }}
			</div>

			<div id="paymentMethod" class="flex flex-align-center-start flex-1" style="--max-width: 19.2%">
				<div class="flex flex-row">
					<div *ngIf="transaction.accountType === 'BANK'" class="badge-item badge-bank">
						<app-icon
							class="bank-icon"
							[name]="'bank-figma'"
							[size]="'20'"
							[color]="'var(--no-items-poker-face-color)'"
							[lineWidth]="'2'"
						></app-icon>
					</div>

					<div *ngIf="transaction.accountType === 'CARD'" class="badge-item badge-card">
						<app-icon
							class="bank-card-icon"
							[name]="'card'"
							[size]="'20'"
							[color]="'var(--no-items-poker-face-color)'"
							[lineWidth]="'2'"
						></app-icon>
					</div>
					<span class="bank-account">
						{{ transaction.customPaymentField | bankNumberCustomFormat }}
						<br />

						<span
							[ngClass]="{
								'bank-account-types': transaction.type !== 'NETS',
								'bank-account-types-net': transaction.type === 'NETS'
							}"
							>{{ transaction.type === "NETS" ? "Net payment" : transaction.type }}</span
						>
					</span>
				</div>
			</div>

			<div
				class="table-status flex flex-align-center-start flex-1"
				*ngIf="!isCancelledRun"
				style="--max-width: 13.2%"
			>
				<span
					[ngClass]="{
						'table-status status-green':
							(transaction.status.name | toString) === 'SUCCESS' ||
							(transaction.status.name | toString) === 'PROCESSED' ||
							(transaction.status.name | toString) === 'COMPLETED',
						'table-status status-red':
							(transaction.status.name | toString) === 'FAILED' ||
							(transaction.status.name | toString) === 'ATTEMPTS_LIMIT_EXCEEDED' ||
							(transaction.status.name | toString) === 'FAILED_TO_BOOK' ||
							(transaction.status.name | toString) === 'ERROR',
						'table-status status-pending':
							(transaction.status.name | toString) === 'PENDING' ||
							(transaction.status.name | toString) === 'PROCESSING',
						'table-status status-booked': (transaction.status.name | toString) === 'BOOKED',
						'table-status status-cancelled': (transaction.status.name | toString) === 'CANCELLED',
						'table-status status-created': (transaction.status.name | toString) === 'CREATED'
					}"
					[attr.data-test]="
						'net-payment-account-list-emp' + employeeExternalId + '-account' + i + '-status-text'
					"
					>{{ transaction.status.name | transactionStatuses }}</span
				>
			</div>

			<span
				class="table-status flex flex-align-center-start flex-1"
				*ngIf="isCancelledRun"
				style="--max-width: 13.2%"
			>
				<span class="status-cancelled">CANCELLED</span>
			</span>

			<div class="table-total-net flex flex-align-center-start flex-1" style="--max-width: 22.85%">
				<span class="total-net-text">
					{{ transaction.amount.value | number : "1.2-2" }}{{ transaction.amount.currency | currencySymbol }}
				</span>
			</div>

			<mat-form-field
				class="view-details flex flex-align-center-start flex-1"
				style="--max-width: 2%"
				[attr.data-test]="'net-payment-account-list-emp' + employeeExternalId + '-account' + i + '-more'"
			>
				<app-icon class="more-dots" [name]="'more'" #trigger [lineWidth]="'1'"></app-icon>
				<mat-select class="options-dropdown" trigger="trigger" #alarmSelect>
					<mat-option
						*ngIf="canViewTransactionHistory"
						(click)="openHistoryDialog(transaction.payoutId, transaction.payMethodId)"
						[attr.data-test]="
							'net-payment-account-list-emp' + employeeExternalId + '-account' + i + '-history-log-button'
						"
					>
						History log
					</mat-option>
					<mat-option
						(click)="goToEmployeeHistory()"
						[attr.data-test]="
							'net-payment-account-list-emp' + employeeExternalId + '-account' + i + '-emp-history-button'
						"
					>
						Employee History
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
	</div>
	<mat-divider *ngIf="!isLast"></mat-divider>
</div>
